import { style } from '@vanilla-extract/css';

export const emoji = style({});
